export default __webpack_public_path__ + "static/media/armbands_of_the_farseeker.bd3daf3d.jpg";